/*
  Drive Live — filtres de collection (sections/dl-guide-intro.liquid)
  Chaque puce est un vrai lien vers l'URL de balise de la collection : sans JS,
  la page se recharge filtrée. Avec JS, on ne remplace que la section de la grille
  (Section Rendering API), on met l'URL à jour et on garde tri et filtres Dawn.
*/
(() => {
  const nav = document.querySelector('[data-dl-chips]');
  const grid = document.getElementById('ProductGridContainer');
  if (!nav || !grid || !window.fetch || !window.history.pushState) return;

  const section = grid.closest('.shopify-section');
  const sectionId = section && section.id.replace('shopify-section-', '');
  if (!sectionId) return;

  const chips = Array.from(nav.querySelectorAll('.dl-chip'));
  const note = nav.querySelector('[data-dl-chips-note]');
  const status = nav.querySelector('[data-dl-chips-status]');
  const cache = new Map();
  let controller = null;
  let lastPath = window.location.pathname;

  // Tri et filtres Dawn survivent au changement de puce ; la pagination, non.
  const keptParams = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    return params.toString();
  };

  const setActive = (path) => {
    let active = null;
    chips.forEach((chip) => {
      const isActive = new URL(chip.href).pathname === path;
      if (isActive) {
        chip.setAttribute('aria-current', 'page');
        active = chip;
      } else {
        chip.removeAttribute('aria-current');
      }
    });

    if (note) {
      note.textContent = '';
      if (active && active.dataset.anchor) {
        const link = document.createElement('a');
        link.href = `#${active.dataset.anchor}`;
        link.textContent = `Lire « ${active.dataset.chapter} » dans le guide`;
        note.appendChild(link);
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
    return active;
  };

  const swap = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    ['ProductGridContainer', 'main-collection-filters'].forEach((id) => {
      const fresh = doc.getElementById(id);
      const current = document.getElementById(id);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    });
    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const fresh = doc.getElementById(id);
      const current = document.getElementById(id);
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        current.classList.remove('loading');
      }
    });
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
    return doc.querySelectorAll('#product-grid > li').length;
  };

  const setBusy = (busy) => {
    const container = document.getElementById('ProductGridContainer');
    const collection = container && container.querySelector('.collection');
    if (container) container.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (collection) collection.classList.toggle('loading', busy);
    nav.classList.toggle('is-loading', busy);
  };

  const load = async (path, push) => {
    const query = keptParams();
    const pageUrl = query ? `${path}?${query}` : path;
    const fetchUrl = `${path}?section_id=${encodeURIComponent(sectionId)}${query ? `&${query}` : ''}`;

    const active = setActive(path);
    if (nav.dataset.titleBase) {
      document.title = active && active.dataset.tag
        ? `${nav.dataset.titleBase} – ${active.dataset.label}`
        : nav.dataset.titleBase;
    }
    if (push) window.history.pushState({ searchParams: query, dlChips: true }, '', pageUrl);
    lastPath = path;

    if (controller) controller.abort();
    controller = new AbortController();
    setBusy(true);

    try {
      let html = cache.get(fetchUrl);
      if (!html) {
        const response = await fetch(fetchUrl, { signal: controller.signal });
        if (!response.ok) throw new Error(response.status);
        html = await response.text();
        cache.set(fetchUrl, html);
      }
      const count = swap(html);
      const label = active ? active.dataset.label : 'Sélection';
      if (status) status.textContent = `${label} : ${count} produit${count > 1 ? 's' : ''}`;
      setBusy(false);
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(pageUrl);
    }
  };

  nav.addEventListener('click', (event) => {
    const chip = event.target.closest('.dl-chip');
    if (!chip || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const path = new URL(chip.href).pathname;
    if (chip.getAttribute('aria-current') === 'page' && path === window.location.pathname) return;
    load(path, true);
  });

  // Retour / avance du navigateur : facets.js ne suit que la query string, on gère le chemin.
  window.addEventListener('popstate', () => {
    if (window.location.pathname === lastPath) return;
    load(window.location.pathname, false);
  });
})();
